import client from './client';

export const createCheckoutSession = (data) => client.post('/api/checkout/create-session', data);
export const confirmOrder = (sessionId) => client.get(`/api/checkout/confirm/${sessionId}`);
